import { Link, useLocation } from 'react-router';
import { NavEntryProps } from './types';

export const NavEntry = (props: NavEntryProps) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');

  function isActiveTab(entry: NavEntryProps) {
    const pathMatches = pathSegments.slice(-1)[0] === entry.pageKey;
    if (entry.activeTab) {
      if (!pathMatches) return false;
      const hash = location.hash.replace('#', '');
      // No hash means the page is showing its first tab (MCV-1464), so
      // highlight the entry marked as the group's default.
      return hash ? hash === entry.activeTab : Boolean(entry.isDefaultTab);
    }
    return pathMatches;
  }

  const active = isActiveTab(props);

  return (
    <Link
      to={{
        pathname: props.href,
        hash: props.activeTab ? `#${props.activeTab}` : undefined,
      }}
      onClick={() => {
        if (props.onSetPage) {
          props.onSetPage(props.pageKey, props.activeTab ? `#${props.activeTab}` : undefined);
        }
        window.scrollTo(0, 0);
      }}
      className="block mx-2"
      state={props.pageKey}
      aria-current={active ? 'page' : undefined}
    >
      <div
        className={`flex items-center gap-2.5 px-3 py-2 rounded-md cursor-pointer transition-colors duration-150 ${
          active
            ? 'bg-white shadow-sm text-primary-50 font-medium'
            : 'text-grey-200 hover:bg-white/50'
        }`}
      >
        {props.icon && (
          <props.icon
            className={`size-4 shrink-0 ${active ? 'text-primary-50' : 'text-grey-400'}`}
          />
        )}
        <p className="text-sm">{props.label}</p>
      </div>
    </Link>
  );
};
